exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.main {\n    border: thin solid silver;\n    margin: 0.6ex;\n    padding: 0.6ex;\n  }\n  \n  div.main div {\n    margin-top: 0.5ex;\n  }\n  \n  div.doi {\n    font-style: italic;\n    font-size: small;\n  }\n  \n  div.isbn, div.issn {\n    font-size: small;\n  }\n  \n  div.authors {\n    font-size: small;\n    font-style: italic;\n  }\n  ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/crossref-record-box/crossref-record-box.component.css
// module id = ../../../../../src/app/crossref-record-box/crossref-record-box.component.css
// module chunks = main